import { faBed, faCar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StatusDrivers from './StatusDrivers';
import ItemStatusDriver from './ItemStatusDriver';

type Props = {
  amountPerState: {
    free: number;
    busy: number;
    onBrake: number;
    workdayNotStarted: number;
    workdayStarted: number;
  };
  statusActive: string;
  isLoadingDrivers: boolean;
  onFilterByStatusDriver: (state: string) => void;
};

const FirstPanelStatusDrivers = ({
  amountPerState: { busy, free, onBrake, workdayNotStarted, workdayStarted },
  statusActive,
  isLoadingDrivers,
  onFilterByStatusDriver,
}: Props): JSX.Element => {

  return (
    <div className="text-xs flex items-center mt-2 mb-1">
      <div className="flex gap-2 md:flex-col lg:flex-col xl:flex-row 2xl:flex-row flex-1">
        <div className="flex gap-1 rounded-2xl border border-secondary-200 bg-whiteLight py-1 dark:border-white/10 dark:bg-darkLight">
          <div className="flex items-center gap-3 justify-center text-gray-400 dark:text-inkMuted-dark pl-4 pr-4 rounded-l-2xl border-r border-secondary-200 dark:border-white/10">
            <div className="flex w-36 items-center gap-2 py-2">
              <FontAwesomeIcon icon={faCar} size="1x" />
              <p className="leading-none text-xs">Turno abierto</p>
            </div>
            <span className={'text-xs text-gray-700 dark:text-ink-dark'}>
              {workdayStarted ?? 0}
            </span>
          </div>
          <StatusDrivers
            busy={busy}
            free={free}
            onBrake={onBrake}
            onFilterByStatusDriver={onFilterByStatusDriver}
            statusActive={statusActive}
            isLoadingDrivers={isLoadingDrivers}
          />
        </div>
        <div className="flex gap-3 rounded-2xl border border-secondary-200 bg-whiteLight py-2 dark:border-white/10 dark:bg-darkLight">
          <div className="flex items-center justify-center gap-2 rounded-l-2xl text-gray-400 dark:text-inkMuted-dark pl-4 pr-4 border-r border-secondary-200 dark:border-white/10">
            <div className="flex w-36 items-center gap-2 py-2">
              <FontAwesomeIcon icon={faBed} size="1x" />
              <p className="leading-none">Turno cerrado</p>
            </div>
            <span className={'text-xs text-gray-700 dark:text-ink-dark'}>
              {workdayNotStarted ?? 0}
            </span>
          </div>
          <div className="py-1 pr-2 flex justify-start">
            <ItemStatusDriver
              status="ON_BRAKE"
              onFilterByStatusDriver={onFilterByStatusDriver}
              borderColor="border-gray-400 dark:border-gray-500"
              bgColor="bg-gray-200 dark:bg-white/10"
              isActive={statusActive === 'ON_BRAKE'}
              label="Fuera de turno"
              value={''}
              color="text-gray-500 dark:text-gray-300"
              loadingColor="#6B7280"
              isLoadingDrivers={isLoadingDrivers}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstPanelStatusDrivers;
